import { ArrowRightIcon } from 'lucide-preact';
import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

import { useProductCard } from './context';

type ProductCardBackButtonProps = Omit<ComponentProps<'button'>, 'onClick'>;

/** Returns to the offer. Not tracked: only opening the panel says anything about intent. */
const ProductCardBackButton = ({ className, children = 'Back', ...props }: ProductCardBackButtonProps) => {
  const { setShowWhatsIncluded } = useProductCard();
  return (
    <button
      type="button"
      className={cn(
        'preflight preflight-button flex items-center justify-center gap-1 text-sm leading-5 text-stone-500',
        className,
      )}
      onClick={() => setShowWhatsIncluded(false)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <ArrowRightIcon className="size-4 rotate-180" />
      <span>{children}</span>
    </button>
  );
};

export default ProductCardBackButton;
